// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-config-arbitrage-payments-modal__switch {
    display: flex;
    align-items: center;
}

.tournament-config-arbitrage-payments-modal_container {
    padding: var(--space-x2) var(--space-x3);
}

.tournament-config-arbitrage-payments-modal__switch-container .baloa-table {
    color: --primary-dark-color;
    margin-top: var(--space-half-quarter);
}

.tournament-config-arbitrage-payments-modal__processing-fee__container .MuiFormGroup-row {
    flex-direction: column;
}

.tournament-config-arbitrage-payments-modal__processing-fee__form-control-label__title .baloa-table-column {
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
}

.tournament-config-arbitrage-payments-modal__processing-fee__form-control-label__title .baloa-username {
    color: var(--basic-gray-color);
}

.tournament-config-arbitrage-payments-modal__processing-fee__form-control-label__title .config-info {
    margin: var(--space-half-quarter) 0 var(--space-half) 0;
}

.tournament-config-arbitrage-payments-modal__set-teams-fee__inputs-value {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tournament-config-arbitrage-payments-modal__set-teams-fee__input,
.tournament-config-arbitrage-payments-modal__set-referees-fee__input,
.tournament-config-arbitrage-payments-modal__referee-assigner__input {
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: var(--space) var(--space-and-half);
    width: 100%;
    font-family: var(--secondary-font);
    font-size: var(--space);
    max-height: var(--space-x3);
}

.tournament-config-arbitrage-payments-modal__set-teams-fee__input:active,
.tournament-config-arbitrage-payments-modal__set-teams-fee__input:focus,
.tournament-config-arbitrage-payments-modal__set-referees-fee__input:active,
.tournament-config-arbitrage-payments-modal__set-referees-fee__input:focus,
.tournament-config-arbitrage-payments-modal__referee-assigner__input:active,
.tournament-config-arbitrage-payments-modal__referee-assigner__input:focus {
    border: 1px solid var(--new-gray-background-color);
    outline: none;
}

.tournament-config-arbitrage-payments-modal__set-referees-fee__container .baloa-names {
    color: var(--primary-very-dark-color);
    margin: var(--space-x2) 0 var(--space-half-quarter) 0;
}

.tournament-config-arbitrage-payments-modal__set-referees-fee__container .baloa-table {
    color: var(--primary-dark-color);
    margin-bottom: var(--space-and-half);
}

.tournament-config-arbitrage-payments-modal__set-referees-fee__input-values {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tournament-config-arbitrage-payments-modal__referee-assigner__container .baloa-names {
    color: var(--primary-very-dark-color);
    margin: var(--space-x2) 0 var(--space-half-quarter) 0;
}

.tournament-config-arbitrage-payments-modal__referee-assigner__container .baloa-table {
    color: var(--primary-dark-color);
    margin-bottom: var(--space-and-half);
}

.tournament-config-arbitrage-payments-modal__btns-action__info-text {
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid var(--new-input-background-color);
    border-bottom: 1px solid var(--new-input-background-color);
    padding: var(--space-and-half) 0;
}

.tournament-config-arbitrage-payments-modal__btns-action__amount-info {
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid var(--new-input-background-color);
    border-bottom: 1px solid var(--new-input-background-color);
    padding: var(--space-half) 0;  
    flex-direction: column; 
}

.tournament-config-arbitrage-payments-modal__btns-action {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: var(--space-and-half);
}

.tournament-config-arbitrage-payments-modal__processing-fee__container {
    margin: var(--space-x2) 0;
}

.tournament-config-arbitrage-payments-modal__processing-fee__container .baloa-names {
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space);
}

.tournament-config-arbitrage-payments-modal__processing-fee__container .MuiFormControlLabel-root {
    align-items: flex-start;
}

.tournament-config-arbitrage-payments-modal__processing-fee__container .MuiFormControlLabel-root:first-of-type {
    margin-bottom: var(--space);
}

.tournament-config-arbitrage-payments-modal__processing-fee__container .MuiIconButton-root {
    padding: 0 var(--space-half);
}

.tournament-config-arbitrage-payments-modal__set-teams-fee__team .baloa-username {
    margin-bottom: var(--space-half);
    color: var(--primary-very-dark-color);
}

.tournament-config-arbitrage-payments-modal__set-referees-fee__referee .baloa-username {
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space-half);
}

.tournament-config-arbitrage-payments-modal__set-referees-fee__referee {
    width: 252px;
}

.tournament-config-arbitrage-payments-modal__set-referees-fee__rigth-col .tournament-config-arbitrage-payments-modal__set-referees-fee__referee:first-of-type,
.tournament-config-arbitrage-payments-modal__set-referees-fee__left-col .tournament-config-arbitrage-payments-modal__set-referees-fee__referee:first-of-type {
    margin-bottom: var(--space-and-half);
}

.tournament-config-arbitrage-payments-modal__referee-assigner .baloa-username {
    margin-bottom: var(--space-half);
    color: var(--primary-very-dark-color);
    white-space: nowrap;
}

.tournament-config-arbitrage-payments-modal__referee-assigner {
    width: 224px;
}

.tournament-config-arbitrage-payments-modal__btns-action .secondary-button {
    color: var(--primary-dark-color);
    border: none;
    margin-right: var(--space-and-half);
}

.tournament-config-arbitrage-payments-modal__btns-action .secondary-button:hover {
    background-color: var(--white-color);    
}

.tournament-config-arbitrage-payments-modal__btns-action__amount-balance {
    display: flex;
    align-items: center;
    justify-content: center;
}

.tournament-config-arbitrage-payments-modal__set-teams-fee__container button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal{
    border-radius: 9px;
    border: 1px solid var(--new-gray-background-color);
    color: var(--primary-dark-color);
    text-transform: unset;
    padding: var(--space) var(--space-x3)
}

.tournament-config-arbitrage-payments-modal__set-teams-fee__container button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal:hover{
    background-color: var(--new-green-color);
    color: var(--white-color);
}

.tournament-config-arbitrage-payments-modal__set-teams-fee__container button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal.Mui-selected{
    background-color: var(--new-green-color);
    color: var(--white-color);
}

.tournament-config-arbitrage-payments-modal__set-teams-fee__container .MuiToggleButtonGroup-root {
    width: 100%;
    justify-content: space-between;
    margin: var(--space-half-quarter) 0 var(--space-x2) 0;
}

.tournament-config-arbitrage-payments-modal__btns-action__info-text .hubicon-info:before {
    margin-right: var(--space-half);
    color: var(--new-green-color);
}

.tournament-config-arbitrage-payments-modal__btns-action__amount-info__values {
    display: flex;
    align-items: center;
    justify-content: center;
}

.tournament-config-arbitrage-payments-modal__btns-action__amount-info__values .baloa-names {
    margin-right: var(--space-quarter);
    color: var(--primary-very-dark-color);
}

.tournament-config-arbitrage-payments-modal__btns-action__amount-info__values:first-of-type {
    margin-bottom: var(--space-half);
}

.tournament-config-arbitrage-payments-modal__btns-action__amount-info__values .baloa-table {
    color: var(--primary-dark-color);
}

.tournament-config-arbitrage-payments-modal__btns-action__amount-info__values .baloa-table.over_value {
    color: var(--error-color);
}

.tournament-config-arbitrage-payments__calculate-fees {
    margin-top: var(--space-half-quarter);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-config-arbitrage-payments-modal/TournamentConfigArbitragePaymentsModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;;;IAGI,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;IAClB,2CAA2C;IAC3C,WAAW;IACX,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;;;;;;IAMI,kDAAkD;IAClD,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,qDAAqD;AACzD;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;IACrC,qDAAqD;AACzD;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uDAAuD;IACvD,0DAA0D;IAC1D,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uDAAuD;IACvD,0DAA0D;IAC1D,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,gCAAgC;IAChC,qBAAqB;IACrB;AACJ;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,qDAAqD;AACzD;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;AACzC","sourcesContent":[".tournament-config-arbitrage-payments-modal__switch {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-config-arbitrage-payments-modal_container {\n    padding: var(--space-x2) var(--space-x3);\n}\n\n.tournament-config-arbitrage-payments-modal__switch-container .baloa-table {\n    color: --primary-dark-color;\n    margin-top: var(--space-half-quarter);\n}\n\n.tournament-config-arbitrage-payments-modal__processing-fee__container .MuiFormGroup-row {\n    flex-direction: column;\n}\n\n.tournament-config-arbitrage-payments-modal__processing-fee__form-control-label__title .baloa-table-column {\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-config-arbitrage-payments-modal__processing-fee__form-control-label__title .baloa-username {\n    color: var(--basic-gray-color);\n}\n\n.tournament-config-arbitrage-payments-modal__processing-fee__form-control-label__title .config-info {\n    margin: var(--space-half-quarter) 0 var(--space-half) 0;\n}\n\n.tournament-config-arbitrage-payments-modal__set-teams-fee__inputs-value {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.tournament-config-arbitrage-payments-modal__set-teams-fee__input,\n.tournament-config-arbitrage-payments-modal__set-referees-fee__input,\n.tournament-config-arbitrage-payments-modal__referee-assigner__input {\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: var(--space) var(--space-and-half);\n    width: 100%;\n    font-family: var(--secondary-font);\n    font-size: var(--space);\n    max-height: var(--space-x3);\n}\n\n.tournament-config-arbitrage-payments-modal__set-teams-fee__input:active,\n.tournament-config-arbitrage-payments-modal__set-teams-fee__input:focus,\n.tournament-config-arbitrage-payments-modal__set-referees-fee__input:active,\n.tournament-config-arbitrage-payments-modal__set-referees-fee__input:focus,\n.tournament-config-arbitrage-payments-modal__referee-assigner__input:active,\n.tournament-config-arbitrage-payments-modal__referee-assigner__input:focus {\n    border: 1px solid var(--new-gray-background-color);\n    outline: none;\n}\n\n.tournament-config-arbitrage-payments-modal__set-referees-fee__container .baloa-names {\n    color: var(--primary-very-dark-color);\n    margin: var(--space-x2) 0 var(--space-half-quarter) 0;\n}\n\n.tournament-config-arbitrage-payments-modal__set-referees-fee__container .baloa-table {\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-and-half);\n}\n\n.tournament-config-arbitrage-payments-modal__set-referees-fee__input-values {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.tournament-config-arbitrage-payments-modal__referee-assigner__container .baloa-names {\n    color: var(--primary-very-dark-color);\n    margin: var(--space-x2) 0 var(--space-half-quarter) 0;\n}\n\n.tournament-config-arbitrage-payments-modal__referee-assigner__container .baloa-table {\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-and-half);\n}\n\n.tournament-config-arbitrage-payments-modal__btns-action__info-text {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-top: 1px solid var(--new-input-background-color);\n    border-bottom: 1px solid var(--new-input-background-color);\n    padding: var(--space-and-half) 0;\n}\n\n.tournament-config-arbitrage-payments-modal__btns-action__amount-info {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-top: 1px solid var(--new-input-background-color);\n    border-bottom: 1px solid var(--new-input-background-color);\n    padding: var(--space-half) 0;  \n    flex-direction: column; \n}\n\n.tournament-config-arbitrage-payments-modal__btns-action {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: var(--space-and-half);\n}\n\n.tournament-config-arbitrage-payments-modal__processing-fee__container {\n    margin: var(--space-x2) 0;\n}\n\n.tournament-config-arbitrage-payments-modal__processing-fee__container .baloa-names {\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space);\n}\n\n.tournament-config-arbitrage-payments-modal__processing-fee__container .MuiFormControlLabel-root {\n    align-items: flex-start;\n}\n\n.tournament-config-arbitrage-payments-modal__processing-fee__container .MuiFormControlLabel-root:first-of-type {\n    margin-bottom: var(--space);\n}\n\n.tournament-config-arbitrage-payments-modal__processing-fee__container .MuiIconButton-root {\n    padding: 0 var(--space-half);\n}\n\n.tournament-config-arbitrage-payments-modal__set-teams-fee__team .baloa-username {\n    margin-bottom: var(--space-half);\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-config-arbitrage-payments-modal__set-referees-fee__referee .baloa-username {\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space-half);\n}\n\n.tournament-config-arbitrage-payments-modal__set-referees-fee__referee {\n    width: 252px;\n}\n\n.tournament-config-arbitrage-payments-modal__set-referees-fee__rigth-col .tournament-config-arbitrage-payments-modal__set-referees-fee__referee:first-of-type,\n.tournament-config-arbitrage-payments-modal__set-referees-fee__left-col .tournament-config-arbitrage-payments-modal__set-referees-fee__referee:first-of-type {\n    margin-bottom: var(--space-and-half);\n}\n\n.tournament-config-arbitrage-payments-modal__referee-assigner .baloa-username {\n    margin-bottom: var(--space-half);\n    color: var(--primary-very-dark-color);\n    white-space: nowrap;\n}\n\n.tournament-config-arbitrage-payments-modal__referee-assigner {\n    width: 224px;\n}\n\n.tournament-config-arbitrage-payments-modal__btns-action .secondary-button {\n    color: var(--primary-dark-color);\n    border: none;\n    margin-right: var(--space-and-half);\n}\n\n.tournament-config-arbitrage-payments-modal__btns-action .secondary-button:hover {\n    background-color: var(--white-color);    \n}\n\n.tournament-config-arbitrage-payments-modal__btns-action__amount-balance {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tournament-config-arbitrage-payments-modal__set-teams-fee__container button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal{\n    border-radius: 9px;\n    border: 1px solid var(--new-gray-background-color);\n    color: var(--primary-dark-color);\n    text-transform: unset;\n    padding: var(--space) var(--space-x3)\n}\n\n.tournament-config-arbitrage-payments-modal__set-teams-fee__container button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal:hover{\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.tournament-config-arbitrage-payments-modal__set-teams-fee__container button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal.Mui-selected{\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.tournament-config-arbitrage-payments-modal__set-teams-fee__container .MuiToggleButtonGroup-root {\n    width: 100%;\n    justify-content: space-between;\n    margin: var(--space-half-quarter) 0 var(--space-x2) 0;\n}\n\n.tournament-config-arbitrage-payments-modal__btns-action__info-text .hubicon-info:before {\n    margin-right: var(--space-half);\n    color: var(--new-green-color);\n}\n\n.tournament-config-arbitrage-payments-modal__btns-action__amount-info__values {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tournament-config-arbitrage-payments-modal__btns-action__amount-info__values .baloa-names {\n    margin-right: var(--space-quarter);\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-config-arbitrage-payments-modal__btns-action__amount-info__values:first-of-type {\n    margin-bottom: var(--space-half);\n}\n\n.tournament-config-arbitrage-payments-modal__btns-action__amount-info__values .baloa-table {\n    color: var(--primary-dark-color);\n}\n\n.tournament-config-arbitrage-payments-modal__btns-action__amount-info__values .baloa-table.over_value {\n    color: var(--error-color);\n}\n\n.tournament-config-arbitrage-payments__calculate-fees {\n    margin-top: var(--space-half-quarter);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
